<template>
  <el-dialog
    :visible.sync="showDialog"
    :before-close="handleClose"
    :width="modalWidth"
    top="10vh"
    custom-class="custom-scrollable"
  >
    <div>
      <div class="text-black mb-12 font-bold flex justify-center text-xl">
        Deposit
      </div>
      <div class="flex my-3 justify-between border-b border-gray-9 pb-6">
        <div class="flex items-center">
          <pending-deposit-icon />
          <div class="lg:ml-4 ml-1 text-black-1 font-semibold flex flex-col">
            <div>Pending Deposit</div>
            <div class="text-xs font-normal">
              {{ $dayjs(DepositInfo.createdAt).format('DD, MMM YYYY') }}
            </div>
          </div>
        </div>
        <div
          @click="proceedToEdit"
          class="cursor-pointer lg:ml-12 ml-3 text-black-1 mr-3 font-semibold flex flex-col"
        >
          <div class="text-blue-1">+ {{ parseMoney(DepositInfo.amount) }}</div>
          <div class="text-xs font-normal flex ml-3 items-center text-orange-2">
            <span class="mr-1"><edit-pen-icon /></span>
            Edit
          </div>
        </div>
      </div>

      <div class="mb-4">
        <div class="flex pb-1 justify-between">
          <div class="text-sm font-normal">Payment Method</div>
          <div class="text-sm font-semibold">Wire transfer</div>
        </div>
        <div class="md:flex justify-between">
          <div class="text-xs italic font-normal">Note:</div>
          <div
            style="word-break: normal"
            class="text-xs md:pl-4 max-w-xs ma font-normal italic"
          >
            Wire transfer transaction takes between 2-4 business days before it
            gets cleared. Please be patient.
          </div>
        </div>
      </div>
      <div class="md:flex text-white justify-between w-full md:mt-12">
        <div
          @click="proceedToEdit"
          class="h-12 bg-white cursor-pointer font-semibold hover:opacity-80 flex text-primary items-center justify-center border border-primary rounded-full px-14"
        >
          Edit Amount
        </div>
        <div
          @click="showDepositDetails"
          class="h-12 bg-primary cursor-pointer hover:opacity-80 font-semibold flex mt-2 md:mt-0 items-center rounded-3xl px-10 md:mr-2"
        >
          See Bank Account
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { ParseMoney } from '@/utils/helpers'
import breakpoints from '@/utils/breakpoints.js'

export default {
  data () {
    return {
      breakpoints,
      showDepositAmountDialog: false
    }
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    parseMoney (val) {
      return ParseMoney(val)
    },
    proceedToEdit () {
      this.$emit('closeDialog')
      this.$emit('editPendingDeposit', 'depositAmount')
    },
    showDepositDetails () {
      this.$emit('closeDialog')
      this.$emit('showDepositDetails', 'selectTransfer')
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    DepositInfo () {
      return this.$store.state.transactions.transactions.items[0]
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  components: {
    EditPenIcon: () => import('@/assets/icons/EditPenIcon.vue'),
    PendingDepositIcon: () => import('@/assets/icons/PendingDepositIcon.vue')
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 30px;
  padding: 20px;
}
>>> .el-dialog__body {
  padding: 10px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
